import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";
import { attachTokenInterceptor } from "../services/apiClient";

export function useInitApiAuth() {
  const { instance, accounts } = useMsal();

  useEffect(() => {
    if (accounts.length > 0) {
      attachTokenInterceptor(instance, accounts[0]);
    }
  }, [accounts]);
}
